import styled from 'styled-components'

export const AudioRadius = styled.div`
position: absolute;
transform: translate(-50%, -50%);
left: 50%;
top: 50%;
border: 2px dotted #ccc;
width: 2200px;
height: 2200px;
display: block;
border-radius: 1100px;
pointer-events: none;
background: radial-gradient();
z-index: -100;
`
